import { theme } from '../../../themes/main';

export const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', lg: 'row' },
    width: '100%',
  },
  saveSearchWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    whiteSpace: 'nowrap',
    order: { xs: 1, lg: 2 },
  },
  saveSearchButton: {
    color: theme.palette.primary.main,
    py: theme.spacing(5),
    fontSize: 14,
    '&:focus-visible, &.Mui-focusVisible': {
      outline: `2px solid ${theme.palette.action.focus}`,
      outlineOffset: '2px',
    },
  },
  contentWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    mt: { xs: 0, sm: 3, md: 0 },
    mb: 0,
    order: { xs: 2, lg: 1 },
  },
  headingWrapper: {
    display: 'flex',
    alignItems: { lg: 'center' },
    pl: { xs: 0, text: 6 },
    pr: 2,
  },
  headingText: {
    mb: { xs: 6, sm: 0, md: 0, lg: 6 },
    mt: { xs: 2, sm: 0, md: 0 },
    fontSize: { xs: 18, lg: 30 },
  },
  divider: {
    display: { sm: 'block', text: 'none' },
    my: { xs: 5, sm: 6 },
    order: 3,
  },
};
